(function () {
  'use strict';

  var addToCartSelector = '[data-add-to-cart]';
  var cartToggleSelector = '[data-cart-drawer-toggle]';
  var subscriptionUpsellSelector = '[data-nom-cart-subscription-upsell]';

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function customCartIsBusy() {
    return window.NomCartSubscriptionSwitching === true || !!(
      window.NomSiteCart &&
      typeof window.NomSiteCart.isBusy === 'function' &&
      window.NomSiteCart.isBusy()
    );
  }

  function blockEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', function (event) {
    if (!customCartIsBusy()) return;

    var addButton = closest(event.target, addToCartSelector);
    var cartToggle = closest(event.target, cartToggleSelector);
    var subscriptionUpsell = closest(event.target, subscriptionUpsellSelector);

    if (addButton || cartToggle || subscriptionUpsell) {
      blockEvent(event);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (!customCartIsBusy()) return;

    var form = event.target;

    if (form && typeof form.querySelector === 'function' && form.querySelector(addToCartSelector)) {
      blockEvent(event);
    }
  }, true);
})();
